import { IUserAccountStore } from '../index'

export default function(state: IUserAccountStore): IUserAccountStore {
  return {
    ...state,
    credentials: {
      accessToken: null,
    },
    isAuthorizing: false,
  }
}
